import { getTestId } from '@airtel/air-design-system';
var cardSliderBreakPoint = {
  xs: {
    slidesPerPage: 1,
    slidesToScroll: 1,
    itemSpacing: 0,
    seekGap: 0
  },
  sm: {
    slidesPerPage: 1,
    slidesToScroll: 1,
    itemSpacing: 0,
    seekGap: 0
  },
  md: {
    slidesPerPage: 1,
    slidesToScroll: 1,
    itemSpacing: 0,
    seekGap: 0
  },
  lg: {
    slidesPerPage: 1,
    slidesToScroll: 1,
    itemSpacing: 0,
    seekGap: 0
  },
  xl: {
    slidesPerPage: 1,
    slidesToScroll: 1,
    itemSpacing: 0,
    seekGap: 0
  }
};
export var defaultProps = Object.assign({
  data: Array.from({
    length: 4
  }, () => ({
    imageUrl: {
      desktop: 'https://assets.airtel.in/teams/simplycms/web/images/Image_349.png',
      mobile: 'https://assets.airtel.in/teams/simplycms/web/images/Image_349.png'
    },
    onPress: {
      from: 'child'
    }
  })),
  carouselType: 'IMAGE',
  breakPoints: cardSliderBreakPoint,
  theme: 'light',
  heightConfig: {
    desktop: 280,
    mobile: 280
  },
  onLeftNavigationPress: {},
  onRightNavigationPress: {},
  isPressable: true,
  onPress: {
    from: 'parent'
  },
  onUserAction: function onUserAction() {
    for (var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++) {
      data[_key] = arguments[_key];
    }
    console.log(JSON.stringify(data));
  }
}, getTestId('CarouselWidgetContainer'));
export var ImageVideoSlideProps = {
  data: [{
    imageUrl: {
      desktop: 'https://assets.airtel.in/teams/simplycms/web/images/Image_349.png',
      mobile: 'https://assets.airtel.in/teams/simplycms/web/images/Image_349.png'
    },
    type: 'image'
  }, {
    imageUrl: {
      desktop: 'https://assets.airtel.in/teams/simplycms/web/images/Image_349.png',
      mobile: 'https://assets.airtel.in/teams/simplycms/web/images/Image_349.png'
    },
    type: 'image'
  }, {
    type: 'youtube-embedded-video',
    videoId: 'G0cO4ry9rxI'
  }, {
    imageUrl: {
      desktop: 'https://assets.airtel.in/teams/simplycms/web/images/Image_349.png',
      mobile: 'https://assets.airtel.in/teams/simplycms/web/images/Image_349.png'
    },
    type: 'image'
  }, {
    imageUrl: {
      desktop: 'https://assets.airtel.in/teams/simplycms/web/images/Image_349.png',
      mobile: 'https://assets.airtel.in/teams/simplycms/web/images/Image_349.png'
    },
    type: 'image'
  }],
  aspectRatio: 1.17,
  loop: true,
  showIndicators: true,
  carouselType: 'IMAGE-VIDEO'
};